import * as u from "react";
import M from "react";
import * as Er from "react-dom";
var fe = { exports: {} }, J = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $e;
function Rr() {
  if ($e)
    return J;
  $e = 1;
  var r = M, t = Symbol.for("react.element"), o = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, i = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, c = { key: !0, ref: !0, __self: !0, __source: !0 };
  function p(l, f, v) {
    var m, y = {}, O = null, C = null;
    v !== void 0 && (O = "" + v), f.key !== void 0 && (O = "" + f.key), f.ref !== void 0 && (C = f.ref);
    for (m in f)
      s.call(f, m) && !c.hasOwnProperty(m) && (y[m] = f[m]);
    if (l && l.defaultProps)
      for (m in f = l.defaultProps, f)
        y[m] === void 0 && (y[m] = f[m]);
    return { $$typeof: t, type: l, key: O, ref: C, props: y, _owner: i.current };
  }
  return J.Fragment = o, J.jsx = p, J.jsxs = p, J;
}
var q = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var We;
function hr() {
  return We || (We = 1, process.env.NODE_ENV !== "production" && function() {
    var r = M, t = Symbol.for("react.element"), o = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), p = Symbol.for("react.provider"), l = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), O = Symbol.for("react.lazy"), C = Symbol.for("react.offscreen"), A = Symbol.iterator, x = "@@iterator";
    function T(e) {
      if (e === null || typeof e != "object")
        return null;
      var n = A && e[A] || e[x];
      return typeof n == "function" ? n : null;
    }
    var j = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(e) {
      {
        for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), d = 1; d < n; d++)
          a[d - 1] = arguments[d];
        I("error", e, a);
      }
    }
    function I(e, n, a) {
      {
        var d = j.ReactDebugCurrentFrame, R = d.getStackAddendum();
        R !== "" && (n += "%s", a = a.concat([R]));
        var h = a.map(function(E) {
          return String(E);
        });
        h.unshift("Warning: " + n), Function.prototype.apply.call(console[e], console, h);
      }
    }
    var k = !1, K = !1, L = !1, re = !1, Ue = !1, ve;
    ve = Symbol.for("react.module.reference");
    function Ye(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === s || e === c || Ue || e === i || e === v || e === m || re || e === C || k || K || L || typeof e == "object" && e !== null && (e.$$typeof === O || e.$$typeof === y || e.$$typeof === p || e.$$typeof === l || e.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === ve || e.getModuleId !== void 0));
    }
    function Be(e, n, a) {
      var d = e.displayName;
      if (d)
        return d;
      var R = n.displayName || n.name || "";
      return R !== "" ? a + "(" + R + ")" : a;
    }
    function me(e) {
      return e.displayName || "Context";
    }
    function D(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case s:
          return "Fragment";
        case o:
          return "Portal";
        case c:
          return "Profiler";
        case i:
          return "StrictMode";
        case v:
          return "Suspense";
        case m:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case l:
            var n = e;
            return me(n) + ".Consumer";
          case p:
            var a = e;
            return me(a._context) + ".Provider";
          case f:
            return Be(e, e.render, "ForwardRef");
          case y:
            var d = e.displayName || null;
            return d !== null ? d : D(e.type) || "Memo";
          case O: {
            var R = e, h = R._payload, E = R._init;
            try {
              return D(E(h));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var $ = Object.assign, Y = 0, ye, ge, Ee, Re, he, be, _e;
    function Ce() {
    }
    Ce.__reactDisabledLog = !0;
    function He() {
      {
        if (Y === 0) {
          ye = console.log, ge = console.info, Ee = console.warn, Re = console.error, he = console.group, be = console.groupCollapsed, _e = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: Ce,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        Y++;
      }
    }
    function Je() {
      {
        if (Y--, Y === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: $({}, e, {
              value: ye
            }),
            info: $({}, e, {
              value: ge
            }),
            warn: $({}, e, {
              value: Ee
            }),
            error: $({}, e, {
              value: Re
            }),
            group: $({}, e, {
              value: he
            }),
            groupCollapsed: $({}, e, {
              value: be
            }),
            groupEnd: $({}, e, {
              value: _e
            })
          });
        }
        Y < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var te = j.ReactCurrentDispatcher, ne;
    function G(e, n, a) {
      {
        if (ne === void 0)
          try {
            throw Error();
          } catch (R) {
            var d = R.stack.trim().match(/\n( *(at )?)/);
            ne = d && d[1] || "";
          }
        return `
` + ne + e;
      }
    }
    var oe = !1, z;
    {
      var qe = typeof WeakMap == "function" ? WeakMap : Map;
      z = new qe();
    }
    function Se(e, n) {
      if (!e || oe)
        return "";
      {
        var a = z.get(e);
        if (a !== void 0)
          return a;
      }
      var d;
      oe = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var h;
      h = te.current, te.current = null, He();
      try {
        if (n) {
          var E = function() {
            throw Error();
          };
          if (Object.defineProperty(E.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(E, []);
            } catch (w) {
              d = w;
            }
            Reflect.construct(e, [], E);
          } else {
            try {
              E.call();
            } catch (w) {
              d = w;
            }
            e.call(E.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (w) {
            d = w;
          }
          e();
        }
      } catch (w) {
        if (w && d && typeof w.stack == "string") {
          for (var g = w.stack.split(`
`), P = d.stack.split(`
`), _ = g.length - 1, S = P.length - 1; _ >= 1 && S >= 0 && g[_] !== P[S]; )
            S--;
          for (; _ >= 1 && S >= 0; _--, S--)
            if (g[_] !== P[S]) {
              if (_ !== 1 || S !== 1)
                do
                  if (_--, S--, S < 0 || g[_] !== P[S]) {
                    var N = `
` + g[_].replace(" at new ", " at ");
                    return e.displayName && N.includes("<anonymous>") && (N = N.replace("<anonymous>", e.displayName)), typeof e == "function" && z.set(e, N), N;
                  }
                while (_ >= 1 && S >= 0);
              break;
            }
        }
      } finally {
        oe = !1, te.current = h, Je(), Error.prepareStackTrace = R;
      }
      var U = e ? e.displayName || e.name : "", W = U ? G(U) : "";
      return typeof e == "function" && z.set(e, W), W;
    }
    function Ke(e, n, a) {
      return Se(e, !1);
    }
    function Ge(e) {
      var n = e.prototype;
      return !!(n && n.isReactComponent);
    }
    function X(e, n, a) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Se(e, Ge(e));
      if (typeof e == "string")
        return G(e);
      switch (e) {
        case v:
          return G("Suspense");
        case m:
          return G("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case f:
            return Ke(e.render);
          case y:
            return X(e.type, n, a);
          case O: {
            var d = e, R = d._payload, h = d._init;
            try {
              return X(h(R), n, a);
            } catch {
            }
          }
        }
      return "";
    }
    var B = Object.prototype.hasOwnProperty, Oe = {}, Te = j.ReactDebugCurrentFrame;
    function Z(e) {
      if (e) {
        var n = e._owner, a = X(e.type, e._source, n ? n.type : null);
        Te.setExtraStackFrame(a);
      } else
        Te.setExtraStackFrame(null);
    }
    function ze(e, n, a, d, R) {
      {
        var h = Function.call.bind(B);
        for (var E in e)
          if (h(e, E)) {
            var g = void 0;
            try {
              if (typeof e[E] != "function") {
                var P = Error((d || "React class") + ": " + a + " type `" + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[E] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw P.name = "Invariant Violation", P;
              }
              g = e[E](n, E, d, a, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (_) {
              g = _;
            }
            g && !(g instanceof Error) && (Z(R), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", d || "React class", a, E, typeof g), Z(null)), g instanceof Error && !(g.message in Oe) && (Oe[g.message] = !0, Z(R), b("Failed %s type: %s", a, g.message), Z(null));
          }
      }
    }
    var Xe = Array.isArray;
    function ie(e) {
      return Xe(e);
    }
    function Ze(e) {
      {
        var n = typeof Symbol == "function" && Symbol.toStringTag, a = n && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return a;
      }
    }
    function Qe(e) {
      try {
        return Pe(e), !1;
      } catch {
        return !0;
      }
    }
    function Pe(e) {
      return "" + e;
    }
    function we(e) {
      if (Qe(e))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ze(e)), Pe(e);
    }
    var H = j.ReactCurrentOwner, er = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, je, ae;
    ae = {};
    function rr(e) {
      if (B.call(e, "ref")) {
        var n = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function tr(e) {
      if (B.call(e, "key")) {
        var n = Object.getOwnPropertyDescriptor(e, "key").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function nr(e, n) {
      if (typeof e.ref == "string" && H.current && n && H.current.stateNode !== n) {
        var a = D(H.current.type);
        ae[a] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', D(H.current.type), e.ref), ae[a] = !0);
      }
    }
    function or(e, n) {
      {
        var a = function() {
          xe || (xe = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        a.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: a,
          configurable: !0
        });
      }
    }
    function ir(e, n) {
      {
        var a = function() {
          je || (je = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        a.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: a,
          configurable: !0
        });
      }
    }
    var ar = function(e, n, a, d, R, h, E) {
      var g = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: e,
        key: n,
        ref: a,
        props: E,
        // Record the component responsible for creating this element.
        _owner: h
      };
      return g._store = {}, Object.defineProperty(g._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(g, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: d
      }), Object.defineProperty(g, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
    };
    function sr(e, n, a, d, R) {
      {
        var h, E = {}, g = null, P = null;
        a !== void 0 && (we(a), g = "" + a), tr(n) && (we(n.key), g = "" + n.key), rr(n) && (P = n.ref, nr(n, R));
        for (h in n)
          B.call(n, h) && !er.hasOwnProperty(h) && (E[h] = n[h]);
        if (e && e.defaultProps) {
          var _ = e.defaultProps;
          for (h in _)
            E[h] === void 0 && (E[h] = _[h]);
        }
        if (g || P) {
          var S = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          g && or(E, S), P && ir(E, S);
        }
        return ar(e, g, P, R, d, H.current, E);
      }
    }
    var se = j.ReactCurrentOwner, Ae = j.ReactDebugCurrentFrame;
    function V(e) {
      if (e) {
        var n = e._owner, a = X(e.type, e._source, n ? n.type : null);
        Ae.setExtraStackFrame(a);
      } else
        Ae.setExtraStackFrame(null);
    }
    var ue;
    ue = !1;
    function ce(e) {
      return typeof e == "object" && e !== null && e.$$typeof === t;
    }
    function Ne() {
      {
        if (se.current) {
          var e = D(se.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function ur(e) {
      {
        if (e !== void 0) {
          var n = e.fileName.replace(/^.*[\\\/]/, ""), a = e.lineNumber;
          return `

Check your code at ` + n + ":" + a + ".";
        }
        return "";
      }
    }
    var Ie = {};
    function cr(e) {
      {
        var n = Ne();
        if (!n) {
          var a = typeof e == "string" ? e : e.displayName || e.name;
          a && (n = `

Check the top-level render call using <` + a + ">.");
        }
        return n;
      }
    }
    function De(e, n) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var a = cr(n);
        if (Ie[a])
          return;
        Ie[a] = !0;
        var d = "";
        e && e._owner && e._owner !== se.current && (d = " It was passed a child from " + D(e._owner.type) + "."), V(e), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', a, d), V(null);
      }
    }
    function ke(e, n) {
      {
        if (typeof e != "object")
          return;
        if (ie(e))
          for (var a = 0; a < e.length; a++) {
            var d = e[a];
            ce(d) && De(d, n);
          }
        else if (ce(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var R = T(e);
          if (typeof R == "function" && R !== e.entries)
            for (var h = R.call(e), E; !(E = h.next()).done; )
              ce(E.value) && De(E.value, n);
        }
      }
    }
    function lr(e) {
      {
        var n = e.type;
        if (n == null || typeof n == "string")
          return;
        var a;
        if (typeof n == "function")
          a = n.propTypes;
        else if (typeof n == "object" && (n.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        n.$$typeof === y))
          a = n.propTypes;
        else
          return;
        if (a) {
          var d = D(n);
          ze(a, e.props, "prop", d, e);
        } else if (n.PropTypes !== void 0 && !ue) {
          ue = !0;
          var R = D(n);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof n.getDefaultProps == "function" && !n.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function fr(e) {
      {
        for (var n = Object.keys(e.props), a = 0; a < n.length; a++) {
          var d = n[a];
          if (d !== "children" && d !== "key") {
            V(e), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", d), V(null);
            break;
          }
        }
        e.ref !== null && (V(e), b("Invalid attribute `ref` supplied to `React.Fragment`."), V(null));
      }
    }
    var Me = {};
    function Fe(e, n, a, d, R, h) {
      {
        var E = Ye(e);
        if (!E) {
          var g = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var P = ur(R);
          P ? g += P : g += Ne();
          var _;
          e === null ? _ = "null" : ie(e) ? _ = "array" : e !== void 0 && e.$$typeof === t ? (_ = "<" + (D(e.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : _ = typeof e, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", _, g);
        }
        var S = sr(e, n, a, R, h);
        if (S == null)
          return S;
        if (E) {
          var N = n.children;
          if (N !== void 0)
            if (d)
              if (ie(N)) {
                for (var U = 0; U < N.length; U++)
                  ke(N[U], e);
                Object.freeze && Object.freeze(N);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ke(N, e);
        }
        if (B.call(n, "key")) {
          var W = D(e), w = Object.keys(n).filter(function(gr) {
            return gr !== "key";
          }), le = w.length > 0 ? "{key: someKey, " + w.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Me[W + le]) {
            var yr = w.length > 0 ? "{" + w.join(": ..., ") + ": ...}" : "{}";
            b(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, le, W, yr, W), Me[W + le] = !0;
          }
        }
        return e === s ? fr(S) : lr(S), S;
      }
    }
    function dr(e, n, a) {
      return Fe(e, n, a, !0);
    }
    function pr(e, n, a) {
      return Fe(e, n, a, !1);
    }
    var vr = pr, mr = dr;
    q.Fragment = s, q.jsx = vr, q.jsxs = mr;
  }()), q;
}
process.env.NODE_ENV === "production" ? fe.exports = Rr() : fe.exports = hr();
var F = fe.exports;
function br(r, t = []) {
  let o = [];
  function s(c, p) {
    const l = u.createContext(p), f = o.length;
    o = [...o, p];
    const v = (y) => {
      const { scope: O, children: C, ...A } = y, x = O?.[r]?.[f] || l, T = u.useMemo(() => A, Object.values(A));
      return /* @__PURE__ */ F.jsx(x.Provider, { value: T, children: C });
    };
    v.displayName = c + "Provider";
    function m(y, O) {
      const C = O?.[r]?.[f] || l, A = u.useContext(C);
      if (A)
        return A;
      if (p !== void 0)
        return p;
      throw new Error(`\`${y}\` must be used within \`${c}\``);
    }
    return [v, m];
  }
  const i = () => {
    const c = o.map((p) => u.createContext(p));
    return function(l) {
      const f = l?.[r] || c;
      return u.useMemo(
        () => ({ [`__scope${r}`]: { ...l, [r]: f } }),
        [l, f]
      );
    };
  };
  return i.scopeName = r, [s, _r(i, ...t)];
}
function _r(...r) {
  const t = r[0];
  if (r.length === 1)
    return t;
  const o = () => {
    const s = r.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(c) {
      const p = s.reduce((l, { useScope: f, scopeName: v }) => {
        const y = f(c)[`__scope${v}`];
        return { ...l, ...y };
      }, {});
      return u.useMemo(() => ({ [`__scope${t.scopeName}`]: p }), [p]);
    };
  };
  return o.scopeName = t.scopeName, o;
}
function Le(r, t) {
  if (typeof r == "function")
    return r(t);
  r != null && (r.current = t);
}
function pe(...r) {
  return (t) => {
    let o = !1;
    const s = r.map((i) => {
      const c = Le(i, t);
      return !o && typeof c == "function" && (o = !0), c;
    });
    if (o)
      return () => {
        for (let i = 0; i < s.length; i++) {
          const c = s[i];
          typeof c == "function" ? c() : Le(r[i], null);
        }
      };
  };
}
function de(...r) {
  return u.useCallback(pe(...r), r);
}
// @__NO_SIDE_EFFECTS__
function Ve(r) {
  const t = /* @__PURE__ */ Cr(r), o = u.forwardRef((s, i) => {
    const { children: c, ...p } = s, l = u.Children.toArray(c), f = l.find(Or);
    if (f) {
      const v = f.props.children, m = l.map((y) => y === f ? u.Children.count(v) > 1 ? u.Children.only(null) : u.isValidElement(v) ? v.props.children : null : y);
      return /* @__PURE__ */ F.jsx(t, { ...p, ref: i, children: u.isValidElement(v) ? u.cloneElement(v, void 0, m) : null });
    }
    return /* @__PURE__ */ F.jsx(t, { ...p, ref: i, children: c });
  });
  return o.displayName = `${r}.Slot`, o;
}
// @__NO_SIDE_EFFECTS__
function Cr(r) {
  const t = u.forwardRef((o, s) => {
    const { children: i, ...c } = o;
    if (u.isValidElement(i)) {
      const p = Pr(i), l = Tr(c, i.props);
      return i.type !== u.Fragment && (l.ref = s ? pe(s, p) : p), u.cloneElement(i, l);
    }
    return u.Children.count(i) > 1 ? u.Children.only(null) : null;
  });
  return t.displayName = `${r}.SlotClone`, t;
}
var Sr = Symbol("radix.slottable");
function Or(r) {
  return u.isValidElement(r) && typeof r.type == "function" && "__radixId" in r.type && r.type.__radixId === Sr;
}
function Tr(r, t) {
  const o = { ...t };
  for (const s in t) {
    const i = r[s], c = t[s];
    /^on[A-Z]/.test(s) ? i && c ? o[s] = (...l) => {
      const f = c(...l);
      return i(...l), f;
    } : i && (o[s] = i) : s === "style" ? o[s] = { ...i, ...c } : s === "className" && (o[s] = [i, c].filter(Boolean).join(" "));
  }
  return { ...r, ...o };
}
function Pr(r) {
  let t = Object.getOwnPropertyDescriptor(r.props, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning;
  return o ? r.ref : (t = Object.getOwnPropertyDescriptor(r, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning, o ? r.props.ref : r.props.ref || r.ref);
}
function Jr(r) {
  const t = r + "CollectionProvider", [o, s] = br(t), [i, c] = o(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), p = (x) => {
    const { scope: T, children: j } = x, b = M.useRef(null), I = M.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ F.jsx(i, { scope: T, itemMap: I, collectionRef: b, children: j });
  };
  p.displayName = t;
  const l = r + "CollectionSlot", f = /* @__PURE__ */ Ve(l), v = M.forwardRef(
    (x, T) => {
      const { scope: j, children: b } = x, I = c(l, j), k = de(T, I.collectionRef);
      return /* @__PURE__ */ F.jsx(f, { ref: k, children: b });
    }
  );
  v.displayName = l;
  const m = r + "CollectionItemSlot", y = "data-radix-collection-item", O = /* @__PURE__ */ Ve(m), C = M.forwardRef(
    (x, T) => {
      const { scope: j, children: b, ...I } = x, k = M.useRef(null), K = de(T, k), L = c(m, j);
      return M.useEffect(() => (L.itemMap.set(k, { ref: k, ...I }), () => void L.itemMap.delete(k))), /* @__PURE__ */ F.jsx(O, { [y]: "", ref: K, children: b });
    }
  );
  C.displayName = m;
  function A(x) {
    const T = c(r + "CollectionConsumer", x);
    return M.useCallback(() => {
      const b = T.collectionRef.current;
      if (!b)
        return [];
      const I = Array.from(b.querySelectorAll(`[${y}]`));
      return Array.from(T.itemMap.values()).sort(
        (L, re) => I.indexOf(L.ref.current) - I.indexOf(re.ref.current)
      );
    }, [T.collectionRef, T.itemMap]);
  }
  return [
    { Provider: p, Slot: v, ItemSlot: C },
    A,
    s
  ];
}
function qr(r, t, { checkForDefaultPrevented: o = !0 } = {}) {
  return function(i) {
    if (r?.(i), o === !1 || !i.defaultPrevented)
      return t?.(i);
  };
}
var ee = globalThis?.document ? u.useLayoutEffect : () => {
}, wr = u[" useInsertionEffect ".trim().toString()] || ee;
function Kr({
  prop: r,
  defaultProp: t,
  onChange: o = () => {
  },
  caller: s
}) {
  const [i, c, p] = xr({
    defaultProp: t,
    onChange: o
  }), l = r !== void 0, f = l ? r : i;
  {
    const m = u.useRef(r !== void 0);
    u.useEffect(() => {
      const y = m.current;
      y !== l && console.warn(
        `${s} is changing from ${y ? "controlled" : "uncontrolled"} to ${l ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), m.current = l;
    }, [l, s]);
  }
  const v = u.useCallback(
    (m) => {
      if (l) {
        const y = jr(m) ? m(r) : m;
        y !== r && p.current?.(y);
      } else
        c(m);
    },
    [l, r, c, p]
  );
  return [f, v];
}
function xr({
  defaultProp: r,
  onChange: t
}) {
  const [o, s] = u.useState(r), i = u.useRef(o), c = u.useRef(t);
  return wr(() => {
    c.current = t;
  }, [t]), u.useEffect(() => {
    i.current !== o && (c.current?.(o), i.current = o);
  }, [o, i]), [o, s, c];
}
function jr(r) {
  return typeof r == "function";
}
// @__NO_SIDE_EFFECTS__
function Ar(r) {
  const t = /* @__PURE__ */ Nr(r), o = u.forwardRef((s, i) => {
    const { children: c, ...p } = s, l = u.Children.toArray(c), f = l.find(Dr);
    if (f) {
      const v = f.props.children, m = l.map((y) => y === f ? u.Children.count(v) > 1 ? u.Children.only(null) : u.isValidElement(v) ? v.props.children : null : y);
      return /* @__PURE__ */ F.jsx(t, { ...p, ref: i, children: u.isValidElement(v) ? u.cloneElement(v, void 0, m) : null });
    }
    return /* @__PURE__ */ F.jsx(t, { ...p, ref: i, children: c });
  });
  return o.displayName = `${r}.Slot`, o;
}
// @__NO_SIDE_EFFECTS__
function Nr(r) {
  const t = u.forwardRef((o, s) => {
    const { children: i, ...c } = o;
    if (u.isValidElement(i)) {
      const p = Mr(i), l = kr(c, i.props);
      return i.type !== u.Fragment && (l.ref = s ? pe(s, p) : p), u.cloneElement(i, l);
    }
    return u.Children.count(i) > 1 ? u.Children.only(null) : null;
  });
  return t.displayName = `${r}.SlotClone`, t;
}
var Ir = Symbol("radix.slottable");
function Dr(r) {
  return u.isValidElement(r) && typeof r.type == "function" && "__radixId" in r.type && r.type.__radixId === Ir;
}
function kr(r, t) {
  const o = { ...t };
  for (const s in t) {
    const i = r[s], c = t[s];
    /^on[A-Z]/.test(s) ? i && c ? o[s] = (...l) => {
      const f = c(...l);
      return i(...l), f;
    } : i && (o[s] = i) : s === "style" ? o[s] = { ...i, ...c } : s === "className" && (o[s] = [i, c].filter(Boolean).join(" "));
  }
  return { ...r, ...o };
}
function Mr(r) {
  let t = Object.getOwnPropertyDescriptor(r.props, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning;
  return o ? r.ref : (t = Object.getOwnPropertyDescriptor(r, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning, o ? r.props.ref : r.props.ref || r.ref);
}
var Fr = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Gr = Fr.reduce((r, t) => {
  const o = /* @__PURE__ */ Ar(`Primitive.${t}`), s = u.forwardRef((i, c) => {
    const { asChild: p, ...l } = i, f = p ? o : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ F.jsx(f, { ...l, ref: c });
  });
  return s.displayName = `Primitive.${t}`, { ...r, [t]: s };
}, {});
function zr(r, t) {
  r && Er.flushSync(() => r.dispatchEvent(t));
}
function $r(r, t) {
  return u.useReducer((o, s) => t[o][s] ?? o, r);
}
var Wr = (r) => {
  const { present: t, children: o } = r, s = Lr(t), i = typeof o == "function" ? o({ present: s.isPresent }) : u.Children.only(o), c = de(s.ref, Vr(i));
  return typeof o == "function" || s.isPresent ? u.cloneElement(i, { ref: c }) : null;
};
Wr.displayName = "Presence";
function Lr(r) {
  const [t, o] = u.useState(), s = u.useRef(null), i = u.useRef(r), c = u.useRef("none"), p = r ? "mounted" : "unmounted", [l, f] = $r(p, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return u.useEffect(() => {
    const v = Q(s.current);
    c.current = l === "mounted" ? v : "none";
  }, [l]), ee(() => {
    const v = s.current, m = i.current;
    if (m !== r) {
      const O = c.current, C = Q(v);
      r ? f("MOUNT") : C === "none" || v?.display === "none" ? f("UNMOUNT") : f(m && O !== C ? "ANIMATION_OUT" : "UNMOUNT"), i.current = r;
    }
  }, [r, f]), ee(() => {
    if (t) {
      let v;
      const m = t.ownerDocument.defaultView ?? window, y = (C) => {
        const x = Q(s.current).includes(CSS.escape(C.animationName));
        if (C.target === t && x && (f("ANIMATION_END"), !i.current)) {
          const T = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", v = m.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = T);
          });
        }
      }, O = (C) => {
        C.target === t && (c.current = Q(s.current));
      };
      return t.addEventListener("animationstart", O), t.addEventListener("animationcancel", y), t.addEventListener("animationend", y), () => {
        m.clearTimeout(v), t.removeEventListener("animationstart", O), t.removeEventListener("animationcancel", y), t.removeEventListener("animationend", y);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: u.useCallback((v) => {
      s.current = v ? getComputedStyle(v) : null, o(v);
    }, [])
  };
}
function Q(r) {
  return r?.animationName || "none";
}
function Vr(r) {
  let t = Object.getOwnPropertyDescriptor(r.props, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning;
  return o ? r.ref : (t = Object.getOwnPropertyDescriptor(r, "ref")?.get, o = t && "isReactWarning" in t && t.isReactWarning, o ? r.props.ref : r.props.ref || r.ref);
}
var Ur = u[" useId ".trim().toString()] || (() => {
}), Yr = 0;
function Xr(r) {
  const [t, o] = u.useState(Ur());
  return ee(() => {
    r || o((s) => s ?? String(Yr++));
  }, [r]), r || (t ? `radix-${t}` : "");
}
var Br = u.createContext(void 0);
function Zr(r) {
  const t = u.useContext(Br);
  return r || t || "ltr";
}
export {
  Gr as P,
  Jr as a,
  br as b,
  qr as c,
  zr as d,
  Zr as e,
  Kr as f,
  Xr as g,
  Wr as h,
  ee as i,
  F as j,
  pe as k,
  de as u
};
//# sourceMappingURL=index-099c513a.mjs.map
